import storeLoader from 'app/stores/storeLoader';
import { Link } from 'core/components';
import React from 'react';

/**
 * Links to the policy table with a single policy visible and selected
 */
const FilteredPolicyLink = storeLoader('$alerting.policyCollection')(({ $alerting, id, children, ...rest }) => {
  const policyModel = $alerting.policyCollection.get(id);
  const renderedChildren = typeof children === 'function' ? children(policyModel) : children;
  if (!policyModel) {
    return renderedChildren || `Policy #${id}`;
  }
  return (
    <Link to={`/v4/alerting/policies/?id=${id}`} {...rest}>
      {renderedChildren || policyModel.get('name')}
    </Link>
  );
});

export default FilteredPolicyLink;
